// extracted by mini-css-extract-plugin
export var formContainer = "_ix-0";
export var message = "_ix-1";